import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SettingsProvider } from "@/context/SettingsContext";
import { AuthProvider } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { CartProvider } from "@/context/CartContext";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PolicyPage from "@/pages/PolicyPage";
import Lookbook from "@/pages/Lookbook";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SettingsProvider>
          <AuthProvider>
            <CurrencyProvider>
              <CartProvider>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/pages/:slug" element={<PolicyPage />} />
                  <Route path="/lookbook" element={<Lookbook />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                </Routes>
                <Toaster position="top-right" theme="dark" />
              </CartProvider>
            </CurrencyProvider>
          </AuthProvider>
        </SettingsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
